export const ROUTING = {
  main: '/',
  back: '/powrot',
  unregister: '/potwierdzenie-wyrejestrowania-email'
}
